import * as React from 'react'
import {Helmet} from 'react-helmet-async'
import ScrollToTopOnMount from '~/components/ScrollToTopOnMount'
import LogoutTimer from '~/layouts/LogoutTimer'
import ReduxToast from '~/layouts/ReduxToast'
import {updateGlobalDataFromServer} from '~/redux/massUpdate'

export interface IBaseLayoutProps {
  hasMobileDesigns?: boolean
  children: React.ReactNode
}

export default class BaseLayout extends React.Component<IBaseLayoutProps> {
  componentDidUpdate(_prevProps: IBaseLayoutProps) {
    updateGlobalDataFromServer('pageTransition')
      // dont want to do anything on response
      .then()
      .catch(() =>
        console.warn('Global Data failed to update from server in BaseLayout')
      )
  }

  // some embedded layouts have BaseLayout repeated so you have to supply the return type to render to
  render() {
    const {children, hasMobileDesigns} = this.props
    return (
      <LogoutTimer>
        <div>
          <ReduxToast />
          <ScrollToTopOnMount />
          {!hasMobileDesigns && (
            <Helmet>
              {/* lots of pages don't have mobile designs yet, this makes them slightly better */}
              <meta name="viewport" content="width=500,initial-scale=0.6" />
            </Helmet>
          )}
          {children}
        </div>
      </LogoutTimer>
    )
  }
}
